// Zugang und Parken je Adresse (Auftrag 3, Block 2, 09.10.2026). Alles OPTIONAL:
// Die Erfassung klappt die Fragen unter der Adresse nur auf Wunsch auf
// ("Optionale Angaben für ein genaueres Angebot"), Fehlendes ist nie ein Fehler.
// Die Werte stehen genauso als CHECK in server/migrationen/0020_zugang.sql.
// Die Wertelisten selbst stehen in konstanten.ts. Sie fließen NICHT in die Mengenrechnung, sondern als Hinweise in den Bericht
// (rechnung.ts) und als Zeilen in die Adresskarten (accessRows).

import type { DrivewayType, ElevatorSize, ParkingOption, StairwellType, StepsToDoor } from "./konstanten.ts";

export const STAIRWELL_LABEL: Record<StairwellType, string> = {
  normal: "Normal",
  eng: "Eng oder steil",
  wendel: "Wendeltreppe",
};

export const ELEVATOR_SIZE_LABEL: Record<ElevatorSize, string> = {
  klein: "Klein (nur Personen, Schrank passt nicht)",
  gross: "Groß (ein Bett oder Schrank passt hinein)",
  lastenaufzug: "Lastenaufzug",
};
/** Kurzfassung für Berichte. */
export const ELEVATOR_SIZE_SHORT: Record<ElevatorSize, string> = {
  klein: "klein (Schrank passt nicht)",
  gross: "groß (Bett/Schrank passt)",
  lastenaufzug: "Lastenaufzug",
};

export const STEPS_LABEL: Record<StepsToDoor, string> = {
  keine: "Keine, ebenerdig",
  wenige: "Wenige (1 bis 5)",
  viele: "Viele (mehr als 5)",
};

export const PARKING_LABEL: Record<ParkingOption, string> = {
  frei: "Direkt vor dem Haus ist Platz",
  halteverbot_noetig: "Halteverbot wird nötig",
  halteverbot_vorhanden: "Halteverbot ist schon beantragt",
  unklar: "Weiß ich nicht",
};
export const PARKING_SHORT: Record<ParkingOption, string> = {
  frei: "Platz vor dem Haus",
  halteverbot_noetig: "Halteverbot nötig",
  halteverbot_vorhanden: "Halteverbot beantragt",
  unklar: "unklar",
};

export const DRIVEWAY_LABEL: Record<DrivewayType, string> = {
  strasse: "Normale Straße",
  hof_tor: "Durch Hof oder Tor",
  eng: "Enge oder niedrige Zufahrt",
  fussgaengerzone: "Fußgängerzone oder Lieferzeiten",
};

export type AddressAccess = {
  stairwell?: StairwellType | null;
  elevatorSize?: ElevatorSize | null;
  stepsToDoor?: StepsToDoor | null;
  parking?: ParkingOption | null;
  driveway?: DrivewayType | null;
  note?: string | null;
};

/** Gesetzte Angaben als Zeilen (Bezeichnung, Wert) für Berichte; leer, wenn nichts angegeben wurde. */
export function accessRows(a: AddressAccess & { elevator?: boolean | null }): [string, string][] {
  const rows: [string, string][] = [];
  if (a.stairwell) rows.push(["Treppenhaus", STAIRWELL_LABEL[a.stairwell]]);
  if (a.elevatorSize && a.elevator !== false) rows.push(["Aufzug", ELEVATOR_SIZE_SHORT[a.elevatorSize]]);
  if (a.stepsToDoor) rows.push(["Stufen zur Haustür", STEPS_LABEL[a.stepsToDoor]]);
  if (a.parking) rows.push(["Parken", PARKING_SHORT[a.parking]]);
  if (a.driveway) rows.push(["Zufahrt", DRIVEWAY_LABEL[a.driveway]]);
  if (a.note?.trim()) rows.push(["Hinweis des Kunden", a.note.trim()]);
  return rows;
}
